import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ResponseInterface } from "src/app/shared/interfaces";
import { CreateExamInterface, ExamInterface } from "src/app/shared/interfaces/settings/exam";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root",

    deps: [HttpClient],
})
export class ExamService {
    constructor(private httpClient: HttpClient) {}

    getAllExams(): Observable<ResponseInterface<ExamInterface[]>> {
        return this.httpClient.get<ResponseInterface<ExamInterface[]>>(environment.API_URL + "/app/exams/list/");
    }

    create(data: CreateExamInterface): Observable<CreateExamInterface> {
        return this.httpClient.post<CreateExamInterface>(environment.API_URL + "/app/exams/create/", data);
    }

    update(data: CreateExamInterface, id: string): Observable<CreateExamInterface> {
        return this.httpClient.put<CreateExamInterface>(environment.API_URL + `/app/exams/${id}/`, data);
    }
}
